import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-60px symbol-lg-100px symbol-fixed position-relative" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "d-flex align-items-center mb-2" }
const _hoisted_11 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_12 = { class: "d-flex flex-wrap fw-bold fs-6 pe-2" }
const _hoisted_13 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_14 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Administrator ")
const _hoisted_16 = { class: "d-flex flex-wrap fw-bold fs-6 pe-2" }
const _hoisted_17 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2"
}
const _hoisted_18 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_19 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_20 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: _ctx.UserUtils.generateGravatarUrl(_ctx.email, 200),
                alt: "image"
              }, null, 8, _hoisted_6)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.username), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("a", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com006.svg" })
                    ]),
                    _hoisted_15
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("a", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.email), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("ul", _hoisted_20, [
            _createElementVNode("li", _hoisted_21, [
              _createVNode(_component_router_link, {
                to: "/account/overview",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.tabOverview")), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_22, [
              _createVNode(_component_router_link, {
                to: "/account/settings",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.account.tabSettings")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}